import { CandidatureState } from '@model/enumerations/candidature-state.model';
import { ILocation } from '@model/geracaoz/location.model';
import { IQuestion } from '@model/geracaoz/question.model';
import { Duration } from '@model/enumerations/duration.model';
import dayjs from 'dayjs';
import { ITask } from '@model/geracaoz/task.model';
import { IParametrization } from '@model/geracaoz/parametrization.model';

export interface ICandidatureFrontendGeracaoz {
  id?: number;
  name?: string;
  institutionName?: string;
  institutionDistrict?: string;
  slug?: string;
  published?: boolean;
  synthesis?: any;
  duration?: Duration;
  state?: CandidatureState;
  startDate?: dayjs.Dayjs;
  endDate?: dayjs.Dayjs;
  tasks?: ITask[];
  locations?: ILocation[];
  questions?: IQuestion[];
  parametrization?: IParametrization;
}

// noinspection JSUnusedGlobalSymbols
export class CandidatureFrontendGeracaoz implements ICandidatureFrontendGeracaoz {
  constructor(
    public id?: number,
    public name?: string,
    public institutionName?: string,
    public institutionDistrict?: string,
    public slug?: string,
    public published?: boolean,
    public synthesis?: any,
    public state?: CandidatureState,
    public startDate?: dayjs.Dayjs,
    public endDate?: dayjs.Dayjs,
    public tasks?: ITask[],
    public locations?: ILocation[],
    public questions?: IQuestion[],
    public parametrization?: IParametrization
  ) {
    this.published = this.published || false;
  }
}
